import React, { lazy, Suspense } from 'react';
import { RouterProvider, createBrowserRouter } from "react-router-dom";
import Body from './Body';
import ProtectedRoute from './components/UserDashboard/ProtectedRoute';
import NewCheckIn from './components/UserDashboard/NewCheckIn';
// import { UserAuthContextProvider } from './context/UserAuthContext';
const Splash= lazy(() => import('./components/Login/Splash'));
const Login = lazy(() => import('./components/Login/Login'));
const UserDashboard = lazy(() => import('./components/UserDashboard/UserDashboard'));
const UserDetails = lazy(() => import('./components/Login/UserDetails'));
const NewMeeting = lazy(() => import('./components/UserDashboard/NewMeeting'));
const MeetingCertificate = lazy (() => import('./components/UserDashboard/MeetingCertificate'));
const PendingUser = lazy (() => import('./components/UserDashboard/PendingUser'));
const NewTimeSheet = lazy (() => import('./components/UserDashboard/NewTimeSheet'));

const appRouter = createBrowserRouter([
  {
    path: "/",
    element: <Body />,
    children: [
      {
        path: "/",
        element: <Suspense fallback={<></>}><Splash /></Suspense>
      },
      {
        path: "/login",
        element: <Suspense fallback={<></>}><Login /></Suspense>
      },
      {
        path: "/user_dashboard",
        element: <Suspense fallback={<></>}><ProtectedRoute><UserDashboard /></ProtectedRoute></Suspense>,
      },
      {
        path: "/user_details",
        element: <Suspense fallback={<></>}><ProtectedRoute><UserDetails /></ProtectedRoute></Suspense>,
      },
      {
        path: "/pending_approve",
        element: <Suspense fallback={<></>}><ProtectedRoute><PendingUser /></ProtectedRoute></Suspense>,
      },
      {
        path: "/new_meeting",
        element: <Suspense fallback={<></>}><ProtectedRoute><NewMeeting /></ProtectedRoute></Suspense>,
      },
      {
        path: "/meeting_certificate",
        element: <Suspense fallback={<></>}><ProtectedRoute><MeetingCertificate /></ProtectedRoute></Suspense>,
      },
      {
        path: "/new_checkin",
        element: <Suspense fallback={<></>}><ProtectedRoute><NewCheckIn /></ProtectedRoute></Suspense>,
      },
      {
        path: "/new_timesheet",
        element: <Suspense fallback={<></>}><ProtectedRoute><NewTimeSheet /></ProtectedRoute></Suspense>,
      }
    ],
  },
]);

const App = () => {

  return (
    // <UserAuthContextProvider>
      <div className="w-screen">
        <RouterProvider router={appRouter} />
      </div>
    // </UserAuthContextProvider>
  );
}

export default App;